import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { getBooks, getReviews, getAuthors } from '../lib/api';

function matches(text, term) {
  return String(text || '').toLowerCase().includes(term.toLowerCase());
}

function Buscar() {
  const [term, setTerm] = useState('');
  const [results, setResults] = useState(null);
  const [searching, setSearching] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    if (!term.trim()) return;
    setSearching(true);
    try {
      const [{ books }, { reviews }, { authors }] = await Promise.all([
        getBooks(),
        getReviews(),
        getAuthors()
      ]);
      setResults({
        books: books.filter((book) => matches(book.title, term)),
        reviews: reviews.filter((review) => matches(review.title, term)),
        authors: authors.filter((author) => matches(author.name, term))
      });
    } finally {
      setSearching(false);
    }
  }

  const totalResults = results ? results.books.length + results.reviews.length + results.authors.length : null;

  return (
    <div className="page">
      <Seo title="Buscar" description="Busca libros, reseñas y autores en Libros para Viajeros." />
      <h1>Buscar</h1>
      <form className="simple-form" onSubmit={handleSubmit}>
        <label>
          Libros, reseñas o autores
          <input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Ej. La sombra del viento" />
        </label>
        <button type="submit" disabled={searching}>{searching ? 'Buscando…' : 'Buscar'}</button>
      </form>

      {totalResults === 0 && <p className="empty-state">No hemos encontrado resultados para "{term}".</p>}

      {results && totalResults > 0 && (
        <>
          {results.reviews.length > 0 && (
            <>
              <h2>Reseñas</h2>
              <ul>{results.reviews.map((r) => <li key={r.id}><Link to={`/resenas/${r.slug}`}>{r.title}</Link></li>)}</ul>
            </>
          )}
          {results.books.length > 0 && (
            <>
              <h2>Libros</h2>
              <ul>{results.books.map((b) => <li key={b.id}><Link to={`/libros/${b.slug}`}>{b.title}</Link></li>)}</ul>
            </>
          )}
          {results.authors.length > 0 && (
            <>
              <h2>Autores</h2>
              <ul>{results.authors.map((a) => <li key={a.id}><Link to={`/autores/${a.slug}`}>{a.name}</Link></li>)}</ul>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default Buscar;
